var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3543_61020)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7114 36.9332H29.4474C28.9927 36.9332 28.624 37.3019 28.624 37.7566V79.5705C28.624 80.0253 28.9927 80.3939 29.4474 80.3939H85.7114C86.1662 80.3939 86.5348 80.0253 86.5348 79.5705V37.7566C86.5348 37.3019 86.1662 36.9332 85.7114 36.9332Z",
    stroke: "#C5C5C5",
    strokeWidth: 3.67856,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2325 72.23L22.4886 73.2844C22.0568 73.3647 21.635 73.0735 21.5547 72.6417L14.0133 31.4705C13.933 31.0387 14.2242 30.6169 14.656 30.5366L70.0363 20.3944C70.4681 20.3141 70.8899 20.6053 70.9702 21.0371L73.7819 36.3809",
    stroke: "#C5C5C5",
    strokeWidth: 3.67856,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5708 63.3245L71.0804 51.8203C69.9301 50.4257 67.7925 50.4156 66.622 51.7999L66.622 51.7999L52.0162 69.1023L46.955 64.8896C45.9064 64.0141 44.3898 63.9938 43.311 64.8284L43.3109 64.8285L34.7984 71.4471V44.2799L34.8085 44.2699V44.2537C34.8085 43.6125 35.3231 43.0978 35.9643 43.0978H79.415C80.0561 43.0978 80.5708 43.6125 80.5708 44.2537V63.3245ZM40.3536 50.5579C40.2118 53.3023 42.4702 55.5708 45.2248 55.429C47.5846 55.3075 49.4985 53.3936 49.62 51.0339C49.7618 48.2894 47.5034 46.0209 44.7488 46.1627C42.3891 46.2842 40.4752 48.1981 40.3536 50.5579Z",
    fill: "#BFBFBF",
    stroke: "#C5C5C5",
    strokeWidth: 0.0782671
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3543_61020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImgPlaceholder);
export default __webpack_public_path__ + "static/media/no-img-placeholder.09a1b53e8ef298de1f1ff3c71907f03e.svg";
export { ForwardRef as ReactComponent };